import { checkIdentifier } from "@services/level0Resource";
import { useMutation } from "@tanstack/react-query";

export const useValidateLevel0ResourceIdentifier = (
  options: Record<string, any> = {}
) => {
  return useMutation(checkIdentifier, options);
};
